import Link from "next/link";
import { Icon } from "@zapier/zinnia-icons";
import { BetaDataTableCell as Cell, Text } from "@zapier/design-system";
import {
  ConnectionKebabInteractionOption,
  useEmitConnectionKebabInteractionEvent,
} from "@zapier/shared";

import styles from "./ZapCountCell.module.css";
interface Props {
  count?: number;
  href?: string;
}

export function ZapCountCell({ count = 0, href }: Props) {
  const countString = count.toLocaleString();
  const { emit } = useEmitConnectionKebabInteractionEvent();

  const handleClick = () => {
    emit(ConnectionKebabInteractionOption.ViewZaps);
  };

  return (
    <Cell className={styles.cell}>
      {href ? (
        <Link href={href} className={styles.link} onClick={handleClick}>
          <span className={styles.root}>
            <Icon color="TextWeakest" name="miscBoltAlt" size="16" />
            <Text type="Body1">{countString}</Text>
          </span>
        </Link>
      ) : (
        <span className={styles.root}>
          <Icon color="TextWeakest" name="miscBoltAlt" size="16" />
          <Text type="Body1">{countString}</Text>
        </span>
      )}
    </Cell>
  );
}
